import { ChangeDetectionStrategy, Component } from '@angular/core';
import { APropertyTab } from '../../properties/properties.menu.tab';
import { WIDGETREGISTRY } from '../../../../services/dynamic.component.service';

@Component({
    selector: 'jobs-widget-menu',
    templateUrl: './jobs.widget.menu.html',
    styleUrls: ['./jobs.widget.menu.css'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class JobsWidgetMenu extends APropertyTab {
    onItemSet() {
        if (!this.SelectedItem['WidgetProperties']) {
            this.SelectedItem['WidgetProperties'] = {
                ShowAllUsers: false,
                AllUsers: true
            };
            this.ValuesChanged('WidgetProperties');
        }
    }
    ValuesChanged(prop) {
        this.onStyleChanged(prop);
        WIDGETREGISTRY['Jobs'].Changes.next(true);
    }
}
